<template>
	<div class="table-wrapper u-s-m-b-60">
		<vue-element-loading
			:active="status.deleteCart.loading"
			:is-full-screen="true"
			spinner="spinner"
			color="#343a40"
			text="Removing Product"
		/>
		<vue-element-loading
			:active="status.quantity.loading"
			:is-full-screen="true"
			spinner="spinner"
			color="#343a40"
			text="Updating Quantity"
		/>
		<table>
			<thead>
				<tr>
					<th>Product</th>
					<th>Warehouse</th>
					<th>Price</th>
					<th>Quantity</th>
					<th>Subtotal</th>
					<th>Action</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="cart in getCarts" :key="cart.id">
					<td>
						<div class="cart-anchor-image">
							<router-link
								:to="{
									name: 'ProductDetail',
									params: {id: cart.product.id, slug: cart.product.product_slug},
								}"
							>
								<img
									:src="
										API_URL +
										'/storage/uploads/' +
										(cart.product.images.length > 0 ? cart.product.images[0].name : 'no-image.png')
									"
									@error="$event.target.src = 'https://fl-1.cdn.flockler.com/embed/not-found.png'"
									alt="Product"
								/>
								<h6>
									{{ cart.product.product_name }} -
									{{
										cart.combination.attribute_variations.length
											? cart.combination.attribute_variations[0].variation.name
											: ""
									}}
								</h6>
							</router-link>
						</div>
					</td>
					<td>
						<div class="cart-price">{{ cart.warehouse_name }}</div>
					</td>
					<td>
						<div class="cart-price">{{ formatCurrency(cart.unit_price) }}</div>
					</td>
					<td>
						<div class="cart-quantity">
							<div class="quantity">
								<input type="text" class="quantity-text-field" :value="cart.qty" />
								<a
									class="plus-a"
									@click="
										() =>
											updateCart({
												cart_id: cart.id,
												product_id: cart.product.id,
												quantity_type: 'inc',
											})
									"
									data-max="1000"
									>&#43;</a
								>
								<a
									class="minus-a"
									@click="
										() =>
											updateCart({
												cart_id: cart.id,
												product_id: cart.product.id,
												quantity_type: 'desc',
											})
									"
									data-min="1"
									>&#45;</a
								>
							</div>
						</div>
					</td>
					<td>
						<div class="cart-price">{{ formatCurrency(cart.total_price) }}</div>
					</td>
					<td>
						<div class="action-wrapper">
							<!-- <button class="button button-outline-secondary fas fa-sync"></button> -->
							<button
								@click.prevent="
									() =>
										deleteCart({
											cart_id: cart.id,
											product_id: cart.product.id,
										})
								"
								class="button button-outline-secondary fas fa-trash"
							></button>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
	import {mapActions, mapGetters} from "vuex";
	import Spinner from "../Loaders/Spinner.vue";
	import {formatCurrency} from "../../utils/common_functions";

	export default {
		props: ["getCarts"],
		components: {Spinner},
		computed: {...mapGetters("cart", ["status"])},
		data() {
			return {
				API_URL: process.env.VUE_APP_API_URL,
			};
		},
		methods: {
			formatCurrency,
			...mapActions("cart", ["updateCart", "deleteCart"]),
		},
	};
</script>

<style></style>
